module.exports = __webpack_public_path__ + "static/social-share-8033d948c35326afc0f63b8c4194158f.png";